<template>
  <b-row style="height: 100%">
    <b-col sm="6" lg="5" xl="3">
      <h3 class="mt-4">{{ $t("bom.craneItems") }}</h3>
      <b-form-group class="my-4">
        <b-form-checkbox
          v-model="useJibCrane"
          size="lg"
          switch
        >{{ $t("configuration.addJibCrane") }}</b-form-checkbox>
      </b-form-group>
      <hr />
      <b-form-group class="length-group" :label="$t('jibCrane.length')">
        <b-form-radio-group
          id="length-radio-group"
          v-model="jibCrane.length"
          buttons
          button-variant="outline-primary"
        >
          <b-form-radio :disabled="!useJibCrane" :value="2000">2000mm</b-form-radio>
          <b-form-radio :disabled="!useJibCrane" :value="2500">2500mm</b-form-radio>
          <b-form-radio :disabled="!useJibCrane" :value="3000">3000mm</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group class="placement-group" :label="$t('jibCrane.placement.placement')">
        <b-form-radio-group
          id="placement-radio-group"
          v-model="jibCrane.placement"
          buttons
          button-variant="outline-primary"
        >
          <b-form-radio :disabled="!useJibCrane" value="LEFT">{{ $t("jibCrane.placement.left") }}</b-form-radio>
          <b-form-radio
            :disabled="!useJibCrane"
            value="RIGHT"
          >{{ $t("jibCrane.placement.right") }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group class="height-group" :label="$t('jibCrane.height')">
        <b-input-group append="mm">
          <b-form-input
            data-vv-name="jibCraneHeight"
            type="number"
            :disabled="!useJibCrane"
            :data-vv-as="$t('jibCrane.inputErrorField')"
            v-validate="{
              max_value: columnHeight - span,
              min_value: 0,
              numeric: true,
            }"
            :max="columnHeight - span"
            min="0"
            :step="125"
            :value="jibCrane.height"
            @change="jibCrane.height = $event"
            @blur="
            jibCrane.height = Math.min(
              Math.max(jibCrane.height, 0),
              columnHeight - span
            )
            "
            :class="{
              'is-invalid': errors.has('jibCraneHeight'),
              'height-jib-crane': true,
            }"
          ></b-form-input>
          <span class="invalid-feedback order-last">{{ errors.first("jibCraneHeight") }}</span>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col v-if="useJibCrane">
      <model-viewer
        :src="modelSrc"
        camera-controls
        interaction-prompt="none"
        style="min-height: 300px; width: 100%; height: 100%; outline: 0"
      />
    </b-col>
  </b-row>
</template>
<script>
import "@google/model-viewer"
import { jibCraneSpan } from "../jibCrane";
import { convertConfigurationForModelGen } from '../utils/convert';

export default {
  $_veeValidate: {
    validator: "new",
  },

  data() {
    return {
      jibCrane: this.$store.state.configurations.configuration
        .jibCrane ? this.$store.state.configurations.configuration
        .jibCrane : {
        height: 125,
        craneType: "ALUMINIUM",
        length: "2500",
        placement: "LEFT",
        tiltLimiter: false
      },
      useJibCrane: this.$store.state.configurations.configuration.jibCrane ? true : false,
    };
  },
  computed: {
    modelConfiguration() {
      const json = convertConfigurationForModelGen(
        this.$store.state.modules,
        this.$store.state.configurations.configuration,
        this.$store.state.configurations.configuration.modulePlacements,
        this.$store.state.configurations.emptyModulePlacements,
      )
      return btoa(JSON.stringify(json))
    },
    modelSrc() {
      return `${process.env.VUE_APP_MODEL_GEN_URL}/model.glb?configuration=${this.modelConfiguration}`
    },
    modelIosSrc() {
      return `${process.env.VUE_APP_MODEL_GEN_URL}/model.usdz?configuration=${this.modelConfiguration}`
    },
    columnHeight() {
      return this.$store.state.configurations.configuration.height;
    },
    span() {
      return jibCraneSpan();
    },
    jibCraneMaxHeight() {
      return this.columnHeight - this.span
    }
  },


  methods: {
    useJibCraneClicked() {
      this.configure(this.useJibCrane);
    },
  },
  created() {
    this.$watch(() => [this.useJibCrane, this.jibCrane], () => {
      const height = Math.min(this.jibCrane.height, this.columnHeight - this.span)
      if (this.jibCrane.height != height) this.jibCrane.height = height
      this.$store.commit("configurations/setConfiguration", {
          configuration: {
            ...this.$store.state.configurations.configuration,
            jibCrane: this.useJibCrane ? this.jibCrane : null,
          },
        });
    }, { deep: true })
  }
};
</script>

<style lang="scss" scoped>
.height-jib-crane {
  max-width: 150px;
  text-align: right;
}
.form-group {
  margin-top: 5px;
  margin-bottom: 25px;
}
</style>
